var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7966 19.9393L43.8326 29.7887C45.2593 30.6127 45.2593 32.6713 43.8326 33.4953L29.7966 43.3447C28.3699 44.1687 26.5859 43.1393 26.5859 41.4913V21.7927C26.5859 20.1447 28.3699 19.1153 29.7966 19.9393Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1906 39.6661C3.58793 37.3328 3.2666 34.8848 3.2666 32.3621C3.2666 16.2848 16.2999 3.25146 32.3786 3.25146C48.4559 3.25146 61.4906 16.2848 61.4906 32.3621C61.4906 48.4408 48.4559 61.4741 32.3786 61.4741C25.2213 61.4741 18.6666 58.8915 13.5973 54.6061",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.729a78c6475f2481253839b321583098.svg";
export { ForwardRef as ReactComponent };